// Parteifarben: freie Wahl per Farbwähler, aber gültig und gut unterscheidbar von den anderen Parteien.
import { PARTIES } from '../content/parties';

export const isHex = (c: unknown): c is string => typeof c === 'string' && /^#[0-9a-f]{6}$/i.test(c);

function rgb(c: string): [number, number, number] { const n = parseInt(c.slice(1), 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; }
/** Wahrnehmungsnahe Farbdistanz (gewichtetes RGB, „redmean“). 0 = gleich, ~765 = maximal. */
export function colorDist(a: string, b: string): number {
  const [r1, g1, b1] = rgb(a), [r2, g2, b2] = rgb(b), rm = (r1 + r2) / 2;
  const dr = r1 - r2, dg = g1 - g2, db = b1 - b2;
  return Math.sqrt((2 + rm / 256) * dr * dr + 4 * dg * dg + (2 + (255 - rm) / 256) * db * db);
}
/** Ab dieser Distanz gelten zwei Parteifarben als verwechselbar. */
export const MIN_DIST = 70;
/** Helligkeit 0…1 (relative Luminanz). Sehr dunkle oder sehr helle Farben verschwinden auf dem Hintergrund. */
export function luminance(c: string): number {
  const f = (v: number) => { v /= 255; return v <= .03928 ? v / 12.92 : ((v + .055) / 1.055) ** 2.4; };
  const [r, g, b] = rgb(c); return .2126 * f(r) + .7152 * f(g) + .0722 * f(b);
}

/** Welche Partei hat eine zu ähnliche Farbe? `skip` = eigene Partei-ID. */
export function colorClash(c: string, skip?: string, extra: { n: string; c: string }[] = []): string | null {
  if (!isHex(c)) return null;
  for (const [id, P] of Object.entries<any>(PARTIES)) if (id !== skip && isHex(P.c) && colorDist(c, P.c) < MIN_DIST) return P.n;
  for (const X of extra) if (isHex(X.c) && colorDist(c, X.c) < MIN_DIST) return X.n;
  return null;
}
/** Problem mit der Farbe als Text, sonst null. */
export function colorProblem(c: string, skip?: string, extra: { n: string; c: string }[] = []): string | null {
  if (!isHex(c)) return 'Keine gültige Farbe.';
  const L = luminance(c);
  if (L < .02) return 'Zu dunkel, auf dem Hintergrund kaum zu erkennen.';
  if (L > .85) return 'Zu hell, wirkt fast weiß.';
  const x = colorClash(c, skip, extra);
  return x ? `Zu ähnlich zur Farbe von ${x}.` : null;
}
